import _regeneratorRuntime from "/Users/brian.smith/projects/client-portal-frontend/node_modules/@babel/runtime/regenerator";
import _asyncToGenerator from "/Users/brian.smith/projects/client-portal-frontend/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
var API_KEY;
/**
 * Module to use google's geocoding & reverse geocoding.
 */

var Geocoder;
export default Geocoder = {
  /**
   * Initialize the module.
   * @param {String} apiKey The api key of your application in google.
   * @see https://developers.google.com/maps/documentation/geocoding/intro#geocoding
   */
  init: function init(apiKey) {
    API_KEY = apiKey;
  },

  /**
   * @returns {boolean} True if the module has been initiated. False otherwise.
   */
  get isInit() {
    return !!API_KEY;
  },

  /**
   * @see {@link Geocoder.init}
   * @deprecated
   */
  setApiKey: function setApiKey(API_KEY) {
    this.init(API_KEY);
  },

  /**
   * Do <a href="https://developers.google.com/maps/documentation/geocoding/intro#ReverseGeocoding">(reverse) geocoding</a>, converting geographic coordinates into a human-readable address & vice-versa.
   * Accepted parameters:
   * <ul>
   *     <li>from(Number latitude, Number longitude)</li>
   *     <li>from(Array [latitude, longitude])</li>
   *     <li>from(Object {latitude, longitude})</li>
   *     <li>from(Object {lat, lng})</li>
   *     <li>from(String address)</li>
   * </ul>
   * @returns {Promise.<Object>} Object containing informations about the place at the coordinates.
   * @see https://developers.google.com/maps/documentation/geocoding/intro#GeocodingResponses
   */
  from: function from() {
    for (var _len = arguments.length, params = new Array(_len), _key = 0; _key < _len; _key++) {
      params[_key] = arguments[_key];
    }

    return _asyncToGenerator(
    /*#__PURE__*/
    _regeneratorRuntime.mark(function _callee() {
      var queryParams, url, response, data;
      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              if (Geocoder.isInit) {
                _context.next = 2;
                break;
              }

              throw {
                code: Geocoder.Errors.NOT_INITIATED,
                message: "Geocoder isn't initialized. Call Geocoder.init function (only once), passing it your app's api key as parameter."
              };

            case 2:
              // (latitude, longitude)
              if (!isNaN(params[0]) && !isNaN(params[1])) queryParams = {
                latlng: "".concat(params[0], ",").concat(params[1])
              }; // [latitude, longitude]
              else if (params[0] instanceof Array) queryParams = {
                  latlng: "".concat(params[0][0], ",").concat(params[0][1])
                }; // {latitude, longitude}  or {lat, lng}
                else if (params[0] instanceof Object) queryParams = {
                    latlng: "".concat(params[0].lat || params[0].latitude, ",").concat(params[0].lng || params[0].longitude)
                  }; // address
                  else if (typeof params[0] === 'string') queryParams = {
                      address: params[0]
                    }; // --- start geocoding ---
              // check query params

              if (queryParams) {
                _context.next = 5;
                break;
              }

              throw {
                code: Geocoder.Errors.INVALID_PARAMETERS,
                message: "Invalid parameters : \n" + JSON.stringify(params, null, 2)
              };

            case 5:
              queryParams.key = API_KEY; // build url

              url = 'https://maps.google.com/maps/api/geocode/json?' + toQueryParams(queryParams);
              _context.prev = 7;
              _context.next = 10;
              return fetch(url);

            case 10:
              response = _context.sent;
              _context.next = 16;
              break;

            case 13:
              _context.prev = 13;
              _context.t0 = _context["catch"](7);
              throw {
                code: Geocoder.Errors.FETCHING,
                message: "Error while fetching. Check your network.",
                origin: _context.t0
              };

            case 16:
              _context.prev = 16;
              _context.next = 19;
              return response.json();

            case 19:
              data = _context.sent;
              _context.next = 25;
              break;

            case 22:
              _context.prev = 22;
              _context.t1 = _context["catch"](16);
              throw {
                code: Geocoder.Errors.PARSING,
                message: "Error while parsing response's body into JSON. The response is in the error's 'origin' field. Try to parse it yourself.",
                origin: response
              };

            case 25:
              if (!(data.status !== 'OK')) {
                _context.next = 27;
                break;
              }

              throw {
                code: Geocoder.Errors.SERVER,
                message: "Error from the server while geocoding. The received datas are in the error's 'origin' field. Check it for more informations.",
                origin: data
              };

            case 27:
              return _context.abrupt("return", data);

            case 28:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, null, [[7, 13], [16, 22]]);
    }))();
  },

  /**
   * <a href="https://developers.google.com/maps/documentation/geocoding/intro#geocoding">Geocodes</a>, converting address into a geographic coordinates.
   * Use {@link Geocoder.from} instead.
   * @param {String} address Address to reverse geocode.
   * @returns {Promise.<Object>} Object containing informations about the place and the coordinates.
   * @see https://developers.google.com/maps/documentation/geocoding/intro#Viewports
   * @deprecated
   */
  getFromLocation: function getFromLocation(address) {
    return this.from(address);
  },

  /**
   * Do <a href="https://developers.google.com/maps/documentation/geocoding/intro#ReverseGeocoding">reverse geocoding</a>, converting geographic coordinates into a human-readable address.
   * Use {@link Geocoder.from} instead.
   * @param {Number} lat Latitude coordinate.
   * @param {Number} lng Longitude coordinate.
   * @returns {Promise.<Object>} Object containing informations about the place at the coordinates.
   * @see https://developers.google.com/maps/documentation/geocoding/intro#GeocodingResponses
   * @deprecated
   */
  getFromLatLng: function getFromLatLng(lat, lng) {
    return this.from(lat, lng);
  },

  /**
   * All possible errors.
   */
  Errors: {
    /**
     * Module hasn't been initiated. Call {@link Geocoder.init}.
     */
    NOT_INITIATED: 0,

    /**
     * Parameters are invalid.
     */
    INVALID_PARAMETERS: 1,

    /**
     * Error wile fetching to server.
     * The error.origin property contains the original fetch error.
     */
    FETCHING: 2,

    /**
     * Error while parsing server response.
     * The error.origin property contains the response.
     */
    PARSING: 3,

    /**
     * Error from the server.
     * The error.origin property contains the response's body.
     */
    SERVER: 4
  }
};
/**
 * Convert an object into query parameters.
 * @param {Object} object Object to convert.
 * @returns {string} Encoded query parameters.
 */

function toQueryParams(object) {
  return Object.keys(object).filter(function (key) {
    return !!object[key];
  }).map(function (key) {
    return key + "=" + encodeURIComponent(object[key]);
  }).join("&");
}